import type { InjectionKey } from "vue";
import type { I18n } from "vue-i18n";

// eslint-disable-next-line @typescript-eslint/ban-types
export const I18N_SERVICE_INJECTION_KEY: InjectionKey<
  // eslint-disable-next-line @typescript-eslint/ban-types
  I18n<{}, {}, {}, string, true>
> = Symbol("I18N_SERVICE");
